class CustomHTMLError extends Error {
  constructor (m) {
    super(m)
    this.name = 'CustomHTMLError'
  }
}

export default (scope, m) => {
  throw new CustomHTMLError(`[${scope}] ${m}`)
}

export function warn (scope, m) {
  console.warn(new CustomHTMLError(`[${scope}] ${m}`))
}
